<div class="flex-direction-row gap-12px">
  <img [src]="getIconPathByType(type)" alt="icon">
  <div class="mockup-text">{{ message }}</div>
</div>
